<template>
    <div class="c-multi-search">
        
        <div class="c-multi-search__form">
            <div class="c-multi-search__search-types">
                <h3>Search all transactions</h3>
                <select @change="searchTerm = ''; results = []; searching = false; date = null" v-model="searchType">
                    <option value="" disabled selected>I'd like to search by</option>
                    <option v-for="option in searchOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
            </div>
            <div class="c-multi-search__input-container">
                <h3>{{ searchOptions.find(option => option.value === searchType)?.label }}</h3>
                <input v-if="searchType !== 'date'" :class="searchType" :disabled="!searchType || searchType === ''" type="text" v-model="searchTerm" placeholder="" >
                <VueDatePicker  
                    v-else 
                    v-model="date"
                    :year-range="[2022, new Date().getFullYear()]"
                    min-date="2022-01-01"
                    :range="true"
                    :format="'dd/MM/yyyy'"
                    :enable-time-picker="false"
                >
                </VueDatePicker>
            </div>

            <div class="c-multi-search__search-button" @click="searchTransactions">Search</div>
        </div>
        
        <p class="c-multi-search__note" v-if="searchType">Please note only transactions from 1st Jan 2022 onwards will be displayed.</p>

        <div v-if="searching" class="c-multi-search__results">

            <Loader v-if="loadingResults"/>

            <div v-else-if="error" class="c-multi-search__error">
                {{ error }}
            </div>

            <div class="c-multi-search__results-list" v-else-if="results.length">
                <table class="c-transaction-table is-desktop">
                    <thead>
                        <tr>
                            <th>Document type</th>
                            <th>Document No.</th>
                            <th>PO Number</th>
                            <th>Online Order No. (if applicable)</th>
                            <th>Date</th>
                            <th>Delivery Postcode</th>
                            <th>Amount inc. VAT</th>
                            <th>Status</th>
                            <!-- <th>Paid</th> -->
                            <!-- <th>View PDF</th> -->
                            <!-- <th>Action</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="result in results" :key="result.id">
                            <td>{{ result.attributes.type }}</td>
                            <td>{{ result.id }}</td>
                            <td>{{ result.attributes.poCode || result.attributes.customerPO || '-' }}</td>
                            <td>{{ orderNumber(result) }}</td>
                            <td>{{ formatDateForFrontend(result.attributes.invoiceDate || result.attributes.date ) }}</td>
                            <td>{{ result.attributes.billToPostalCode || '-' }}</td>
                            <td>£{{ transactionTotal(result) }}</td>
                            <td><span :class="result.attributes.status || result.attributes.orderStatus" class="status">{{ result.attributes.status || result.attributes.orderStatus }}</span></td>
                            <!-- <td>{{ result.attributes.isPaid ? 'Yes' : 'No' }}</td> -->
                            <!-- <td></td> -->
                            <!-- <td></td> -->
                        </tr>
                    </tbody>
                </table> 

                <div class="c-multi-search__mobile-result-list">
                    <table class="c-transaction-table is-mobile" v-for="result in results" :key="result.id">
                        <tbody>
                            <tr>
                                <td>Document type</td>
                                <td>{{ result.attributes.type }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Document No.</td>
                                <td>{{ result.id }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>PO Number</td>
                                <td>{{ result.attributes.poCode || result.attributes.customerPO || '-' }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Online order No.</td>
                                <td>{{ result.attributes.orderNumber || '-' }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Date</td>
                                <td>{{ formatDateForFrontend(result.attributes.invoiceDate || result.attributes.date ) }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Delivery Postcode</td>
                                <td>{{ result.attributes.billToPostalCode || '-' }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Amount inc. VAT</td>
                                <td>£{{ transactionTotal(result) }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td><span :class="result.attributes.status || result.attributes.orderStatus" class="status">{{ result.attributes.status || result.attributes.orderStatus }}</span></td>
                                <td></td>
                            </tr>
                            <!-- <tr>
                                <td><span class="view-pdf">View PDF</span></td>
                                <td></td>
                                <td>Pay invoice</td>
                            </tr> -->
                        </tbody>
                    </table>

                </div>

              
            </div>

               
            <p v-else>No results found</p>
        </div>
    </div>
</template>

<script>
    import Loader from './Loader.vue';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'

    export default {
        name: 'TransactionSearch',
        components: {
            VueDatePicker,
            Loader
        },
        data() {
            return {
                error: null,
                searching: false,
                loadingResults: false,
                searchTerm: '',
                searchType: '',
                searchOptions: [
                    { value: 'invoice', label: 'Document Code' },
                    { value: 'PO', label: 'PO Number' },
                    { value: 'reference', label: 'Reference' },
                    { value: 'date', label: 'Date' },
                ],
                results: [],
                date: null
            }
        },
        computed: {
            orderNumber() {
                return (result) => {
                    if(result.attributes.type == 'Invoice' && (result.attributes.customerPO || result.attributes.poCode)) {
                        const poCode = result.attributes.customerPO || result.attributes.poCode;
                        if (!poCode.startsWith('IO')) {
                            return '-';
                        }
                        return '10000' + poCode.replace('IO', '');
                    }
                    return '-';
                };
            },
            transactionTotal()
            {
                return (transaction) => {
                    let amountPrefix = '';
                    const negativeAmountDocumentTypes = ['Credit Memo', 'Invoice Write Off', 'Receipt'];
                    if(negativeAmountDocumentTypes.includes(transaction.attributes.type)){
                        amountPrefix = '-';
                    }
                    return amountPrefix + transaction.attributes.total;
                }
            }
        },
        methods: {
            formatDateForFrontend(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                
                return `${day}/${month}/${year}`;
            },
            formatDateForBackend(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                
                return `${year}-${month}-${day}`;
            },
            async searchTransactions() {
                this.searching = true;
                this.loadingResults = true;

                try {
                    let response = null;

                    if(this.searchType !== 'date'){
                        response = await fetch(
                            `/rest/V1/swallowdental/invoice?type=${this.searchType}&search=${this.searchTerm}`,
                        );
                    }
                    else {
                        response = await fetch(
                            `/rest/V1/swallowdental/invoice?type=date&fromDate=${this.formatDateForBackend(this.date[0])}&toDate=${this.formatDateForBackend(this.date[1])}`,
                        );
                    }

                    if (!response || !response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();
                    this.error = null;
                    this.loadingResults = false;
                    const statusesToFilter = ['Voided'];
                    let reformattedData = Array.isArray(data[0]) ? data[0] : [data[0]];
                    reformattedData = reformattedData.filter(result => (result.attributes.status || result.attributes.orderStatus) && !statusesToFilter.includes(result.attributes.status || result.attributes.orderStatus));
                    reformattedData.sort((a, b) => { 
                        const dateA = new Date(a.attributes.invoiceDate || a.attributes.date);
                        const dateB = new Date(b.attributes.invoiceDate || b.attributes.date);
                        return dateA - dateB;
                    });
                    console.log(reformattedData);
                    this.results = reformattedData;

                } catch (error) {
                    this.loadingResults = false;
                    this.results = [];
                    // this.error = error.message;
                    console.error("Error fetching transactions:", error);
                }
            }
        }
    };
</script>